<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<circle style="fill:#F0F0F0;" cx="256" cy="256" r="256"/>
<g>
	<path style="fill:#338AF3;" d="M512,256c0-101.494-59.065-189.19-144.696-230.598v461.195C452.935,445.19,512,357.493,512,256z"/>
	<path style="fill:#338AF3;" d="M0,256c0,101.493,59.065,189.19,144.696,230.598V25.402C59.065,66.81,0,154.506,0,256z"/>
</g>
<polygon style="fill:#ACABB1;" points="322.898,299.288 279.612,256.002 320.815,214.797 318.948,193.035 307.152,181.237 
	256,232.389 204.848,181.237 193.052,193.035 191.185,214.797 232.388,256.002 189.101,299.288 212.713,322.898 256,279.613 
	299.287,322.898 "/>
<path style="fill:#6DA544;" d="M318.963,193.037l-23.611,23.611c10.071,10.071,16.301,23.984,16.301,39.352
	c0,30.736-24.917,55.652-55.652,55.652S200.348,286.736,200.348,256c0-15.368,6.23-29.281,16.301-39.352l-23.611-23.611
	c-16.115,16.112-26.081,38.373-26.081,62.963c0,49.178,39.866,89.043,89.043,89.043s89.043-39.866,89.043-89.043
	C345.043,231.411,335.077,209.15,318.963,193.037z"/>
</svg>